import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import moment from 'moment';

import { salesCalculateReport } from 'lib/api/sales';
import { makeRowColumn, getHeadObj, getHost } from 'lib/commonLib';
import { setPortal } from 'modules/portal';

import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import CalculateModal from './CalculateModal';

const StatisticsMedia = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({ portal: portal }));

  let initParams = {
    adutSvcTpCode: '02',
    sMth: moment().add(-12, 'month').format('YYYYMM'),
    eMth: moment().format('YYYYMM'),
  };
  let initModal = {
    open: false,
    type: null,
    params: { adutSvcTpCode: '02' },
    modalTitle: '',
    confirmBtnTitle: '',
    message: '',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [modal, setModal] = useState(initModal);
  const [reFetch, setReFetch] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const customized = {
    CALCUL_MEDIA_PYMT_RATE: {
      makeHead: () => {
        return t('지급률');
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'CALCUL_MEDIA_PYMT_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['CALCUL_MEDIA_PYMT_RATE'],
              obj.type,
              obj.format
            )}
          </>
        );
      },
    },
    CALCUL_MEDIA_PYMT_AMT: {
      makeHead: () => {
        return t('매체피(VAT별도)');
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'CALCUL_MEDIA_PYMT_AMT');
        return makeRowColumn(
          rowObj['CALCUL_MEDIA_PYMT_AMT'],
          obj.type,
          obj.format
        );
      },
    },
    SINDY_FEE: {
      makeHead: () => {
        return t('신디피(VAT별도)');
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'SINDY_FEE');
        return makeRowColumn(rowObj['SINDY_FEE'], obj.type, obj.format);
      },
    },
    MEDIA_PYMT_SINDY_FEE_SEP: {
      makeHead: () => {
        return t('매체피+신디피(VAT별도)');
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'MEDIA_PYMT_SINDY_FEE_SEP');
        return makeRowColumn(
          rowObj['MEDIA_PYMT_SINDY_FEE_SEP'],
          obj.type,
          obj.format
        );
      },
    },
    MEDIA_PYMT_SINDY_FEE_INC: {
      makeHead: () => {
        return t('매체피+신디피(VAT포함)');
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'MEDIA_PYMT_SINDY_FEE_INC');
        return makeRowColumn(
          rowObj['MEDIA_PYMT_SINDY_FEE_INC'],
          obj.type,
          obj.format
        );
      },
    },
    MEDIA_GROSS_FEE_INC: {
      makeHead: () => {
        return t('그로스수수료(VAT포함)');
      },
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'MEDIA_GROSS_FEE_INC');
        return makeRowColumn(
          rowObj['MEDIA_GROSS_FEE_INC'],
          obj.type,
          obj.format
        );
      },
    },
    SALES_BILL_VAT_SEP: {
      makeHead: (headsMap) => {
        const result = { content: '', orderFlag: true };
        result.content = (
          <SpanningTableContents topTitle={t('계산서금액 (매출)')} type="head">
            <div style={{ width: 100 }}>{t('VAT별도')}</div>
            <div style={{ width: 100 }}>{t('VAT포함')}</div>
          </SpanningTableContents>
        );
        return result;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <SpanningTableContents>
            <div style={{ width: 100 }}>
              {numeral(rowObj['SALES_BILL_VAT_SEP']).format('#,##0')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['SALES_BILL_VAT_INC']).format('#,##0')}
            </div>
          </SpanningTableContents>
        );
      },
      orderFlag: false,
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
    },
    SALES_BILL_VAT_INC: { merged: true },
    PUR_BILL_VAT_SEP: {
      makeHead: (headsMap) => {
        const result = { content: '', orderFlag: true };
        result.content = (
          <SpanningTableContents topTitle={t('계산서금액 (매입)')} type="head">
            <div style={{ width: 100 }}>{t('VAT별도')}</div>
            <div style={{ width: 100 }}>{t('VAT포함')}</div>
          </SpanningTableContents>
        );
        return result;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <SpanningTableContents>
            <div style={{ width: 100 }}>
              {numeral(rowObj['PUR_BILL_VAT_SEP']).format('#,##0')}
            </div>
            <div style={{ width: 100 }}>
              {numeral(rowObj['PUR_BILL_VAT_INC']).format('#,##0')}
            </div>
          </SpanningTableContents>
        );
      },
      orderFlag: false,
      headStyle: { borderRight: '1px solid #e5e8eb' },
      bodyStyle: { borderRight: '1px solid #e5e8eb' },
    },
    PUR_BILL_VAT_INC: { merged: true },
    CARRY_OVER_AMT: {
      makeBody: (rowObj, headsMap) => {
        const obj = getHeadObj(headsMap, 'CARRY_OVER_AMT');
        return makeRowColumn(rowObj['CARRY_OVER_AMT'], obj.type, obj.format);
      },
      headStyle: { borderRight: '1px solid #e5e8eb' },
      bodyStyle: { borderRight: '1px solid #e5e8eb' },
    },
  };

  /**
   * 테이블 컬럼 추가
   */
  const addColumnList = (() => {
    const result = new Map();
    result.set(-1, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        let resultData;
        let subYear;
        let subMonth;
        if (data.STATS_MTH !== 'total') {
          subYear = String(data.STATS_MTH).substring(0, 4);
          subMonth = String(data.STATS_MTH).substring(4, 7);
          let addParams =
            '&statsMth=' +
            data['STATS_MTH'] +
            '&adutSvcTpCode=' +
            initParams.adutSvcTpCode;

          resultData = (
            <TableBtnWrap>
              <NewButton
                name="mediaPop"
                title={t('수정')}
                iconBtn
                icon="faLink"
                onClick={() => {
                  handlePortalUrl(
                    getHost() +
                      '/v2/acount_media/manage_acount_media_cal_insert.php?year=' +
                      subYear +
                      '&month=' +
                      subMonth
                  );
                }}
                disableRipple
                style={{ backgroundColor: '#79bd2f' }}
                color="#fff"
              />
              <NewButton
                name="history"
                title={t('히스토리')}
                iconBtn
                icon="faHistory"
                onClick={(e) =>
                  handlePortalUrl(
                    '/sales/calculate/history?isPop=1' + addParams
                  )
                }
                disableRipple
                style={{ backgroundColor: '#79bd2f' }}
                color="#fff"
              />
            </TableBtnWrap>
          );
        } else {
          resultData = null;
        }
        return resultData;
      },
    });
    return result;
  })();

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const getModalParam = (newParams) => {
    if (JSON.stringify(modal) !== JSON.stringify(newParams)) {
      setModal(newParams);
    }
  };

  /**
   * 테이블 상태를 갱신
   * @param status
   */
  const handleReFetch = (status) => {
    setReFetch(status);
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = { ...modal, open: false };
    getModalParam(newModal);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useMonthDate
          useDatePresets={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={salesCalculateReport}
        params={params}
        getParam={getParam}
        customized={customized}
        reFetch={reFetch}
        useSearch={false}
        addColumnList={addColumnList}
      />
      {modal.open === true && (
        <CalculateModal
          modal={modal}
          handleReFetch={handleReFetch}
          getModalParam={getModalParam}
          handleModalClose={handleModalClose}
        />
      )}
    </>
  );
};

export default StatisticsMedia;
